'use strict';

angular.module('docketbook')
.controller('companySettingsRolesController', function(userService, $scope, Restangular, $q, $state, $window, $stateParams, accessControl) {
  mixpanel.track("Opened CompanySettings-Roles Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();
  $scope.roleEdit = null;
  $scope.mode = 'list';

  $scope.selected = [];

  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'name'
  };
  $scope.listCount = 0;

  $scope.goTo = function(href) {
    $window.location.href = href;
  }

  $scope.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /******* DATA ********/
  userService.getPermissions(null, function(allPermissions) {
    $scope.allPermissions = allPermissions;
    $scope.remainingPermissions = allPermissions;
  }, function(err) {
    $scope.allPermissions = [];
    $scope.remainingPermissions = [];
  });

  /*******************************/
  /***** Roles Functionality *****/
  /*******************************/

  $scope.loadRolesList = function() {
    $scope.promise = $q(function(resolve, reject) {
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      userService.getRoles(queryParams, function(allRoles) {
        $scope.allRoles = allRoles;
        if ( queryParams.offset <= 0 && allRoles.length < queryParams.limit ) {
          $scope.listCount = allRoles.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function(err) {
        $scope.allRoles = [];
        reject('Error');
      });
    });
  }

  $scope.loadRolesList();

  function getRemainingPermissions(usedPermissions) {
    var remaining = [];

    for ( var i = 0; i < $scope.allPermissions.length; i++ ) {
      var found = false;
      if ( usedPermissions != null ) {
        for ( var j = 0; j < usedPermissions.length; j++ ) {
          if ( usedPermissions[j].permission.id == $scope.allPermissions[i].id ) {
            found = true;
            break;
          }
        }
      }

      if ( !found ) {
        remaining.push($scope.allPermissions[i]);
      }
    }

    return remaining;
  }

  $scope.newRole = function() {
    $scope.roleEdit = {};
    $scope.roleEdit.permissions = [];
    $scope.remainingPermissions = getRemainingPermissions([]);
    //$("#editRoleModal").fadeIn(100);
  }

  $scope.editRole = function(role) {
    $scope.roleEdit = angular.copy(role);
    $scope.roleOriginal = angular.copy(role);
    // populate permissions first
    for ( var i = 0; i < $scope.roleEdit.permissions.length; i++ ) {
      for ( var j = 0; j < $scope.allPermissions.length; j++ ) {
        if ( $scope.allPermissions[j].identifier == $scope.roleEdit.permissions[i].permission ) {
          $scope.roleEdit.permissions[i].permission = $scope.allPermissions[j];
          break;
        }
      }
    }
    $scope.remainingPermissions = getRemainingPermissions($scope.roleEdit.permissions);
  }

  $scope.closeEditRoleModal = function() {
    $scope.roleEdit = null;
  }

  $scope.saveRole = function(role) {
    role.loading = true;
    for ( var i = 0; i < role.permissions.length; i++ ) {
      role.permissions[i].permission = role.permissions[i].permission.identifier;
    }
    userService.saveRole(role, function(roleUpdated) {
      $scope.closeEditRoleModal();
      $scope.loadRolesList();
    }, function(err) {
      role.loading = false;
      $scope.alertService.presentAutoAlert('saveRole', err);
    });
  }

  // Close configure view and open list view
  $scope.showItemList = function() {
    $scope.mode = 'list';
    $scope.roleConfigure = {};
  }

  // Remove a permission from a role
  $scope.removePermissionFromRole = function(permission, role) {
    var index = role.permissions.indexOf(permission);

    if ( index != -1 ) {
      role.permissions.splice(index, 1);
    }

    $scope.remainingPermissions = getRemainingPermissions(role.permissions);
  }

  $scope.addUnusedPermissionToRole = function(permission, role) {
    var newPermissionToAdd = {permission: permission, deny: false};
    role.permissions.push(newPermissionToAdd);
    $scope.remainingPermissions.splice($scope.remainingPermissions.indexOf(permission), 1);
  }

  // Add a permission to a role
  $scope.addPermissionToRole = function(permission, denyPermission, role) {
    var newRolePermission = {};
    newRolePermission.permission = permission;
    if ( denyPermission ) {
      newRolePermission.deny = denyPermission;
    } else {
      newRolePermission.deny = false;
    }

    if ( role.permissions == null ) {
      role.permissions = [];
    }

    role.permissions.push(newRolePermission);
    $scope.remainingPermissions = getRemainingPermissions(role.permissions);
  }

  $scope.deleteSelectedRoles = function() {
    var count = $scope.selected.length;

    swal({
			title: "Are you sure?",
			text: count + " roles will be deleted.",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#DD6B55",
			confirmButtonText: "Yes, delete it!",
			cancelButtonText: "No, cancel!",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm){
			if (isConfirm) {
        userService.deleteBulkRoles($scope.selected, function(failures) {
          if ( failures && failures.length > 0 ) {
            $scope.alertService.presentAutoAlert('deleteBulkRoles', {status:202, requestName: 'Delete bulk roles - failures ' + failures.length + ' of ' + $scope.selected.length});
            $scope.loadRolesList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkRoles',{status:200});
            $scope.loadRolesList();
          }
        });
      }
    });
  }

});



// WEBPACK FOOTER //
// ./src/controllers/companySettings/roles.js